import { useTranslation } from 'next-i18next';
import { Image } from 'components';

import styles from './AutofillTooltip.module.scss';

export const AutofillTooltipContent: React.FC = () => {
  const [t] = useTranslation('candidate-dashboard');

  return (
    <div className={styles.toolTipContainer}>
      <div>
        <Image src={'/images/application.png'} height={139} />
      </div>
      <div className={styles.toolTipText}>
        {t('sidebar-left.autofillTooltipText')}
      </div>
    </div>
  );
};
